import { render, staticRenderFns } from "./RoutineCard.vue?vue&type=template&id=132a4482&scoped=true"
import script from "./RoutineCard.vue?vue&type=script&lang=js"
export * from "./RoutineCard.vue?vue&type=script&lang=js"
import style0 from "./RoutineCard.vue?vue&type=style&index=0&id=132a4482&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "132a4482",
  null
  
)

export default component.exports